<div id="horizontalScrollSnap" class="horizontal-scroll-snap" [ngClass]="{'full-width':fullWidth}"
  (scroll)="onWindowScroll($event)">
  <ng-content></ng-content>
</div>
